import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { FiltroClienteService } from '@shared/services/filtro-cliente/filtro-cliente.service';
import { NavService } from '@shared/services/nav/nav.service';

export const clienteGuard: CanActivateFn = async () => {
  const filtroCliente = inject(FiltroClienteService);
  const nav = inject(NavService);

  const hayCliente = await filtroCliente.hayClienteSeleccionado();
  if (hayCliente) return true;

  nav.volverSeleccionCliente();
  return false;
};
